<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ form.id ? "Editar Inamovilidad" : "Crear Inamovilidad" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :items="causales"
                  :item-value="val => parseInt(val.id)"
                  item-text="valor"
                  label="Causal"
                  v-model="form.id_parametro_causal"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-text-field
                  name="label"
                  type="date"
                  label="Fecha Inicio"
                  v-model="form.fecha_inicio"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  name="label"
                  type="date"
                  label="Fecha Fin"
                  v-model="form.fecha_fin"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex>
                <input
                  id="input"
                  type="file"
                  @change="handleFileUpload()"
                  ref="file"
                  accept="image/*, application/pdf"
                  value="reset"
                />
                <p class="red--text body-1" v-if="error">
                  {{ mensjageerror }}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      causales: [],
      documento_requisito: {},
      error: false,
      cargado: false,
      mensjageerror: ""
    };
  },
  mounted() {
    this.cargarCausales();
    this.$bus.$on("openDialogCrearActualizarInamovilidad", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        this.cargado = true;
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 2048999) {
          this.error = true;
          this.mensjageerror = "El archivo excede el tamaño permitido de 2MB.";
        } 
        else if (this.$refs.file.value === "") {
          this.error = true;
          this.mensjageerror = "Archivo invalido.";
        } else if (!(
          this.$refs.file.files[0].type.includes("application/pdf") ||
          this.$refs.file.files[0].type.includes("image/"))) {
          this.error = true;
          this.mensjageerror = "Formato no admitido por el sistema";
        } 
        else {
          this.error = false;
          this.mensjageerror = "";
        }
        this.file = file;
      }
    },

    async cargarCausales() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
						 query{
              params(tipo:"causal"){
                rows{
                  id
                  valor
                }
              }
              }
					`
        });

        this.causales = respuesta.params.rows;
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      (this.form = {}), (this.loading = false);
      this.file = null;
      this.valid = false;
      this.cargado=false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      if (this.error) {
        return this.error;
      }
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.form.id_parametro_causal = parseInt(
            this.form.id_parametro_causal
          );
          if (this.cargado) {
            let formData = new FormData();
            formData.append("file", this.file);
            let res = await this.$http.post(
              process.env.API_URL + "public/upload",
              formData
            );
            this.form.url_documento = res.data;
          }
          if (this.form.id) {
            const id = this.form.id;
            delete this.form.id;
            delete this.form._user_created;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;
            delete this.form.urldocumento;
            delete this.form.parametro_causal;
            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $inamovilidad: EditInamovilidad!){
									inamovilidadEdit(id: $id, inamovilidad: $inamovilidad){
										id
									}
								}
							`,
              variables: {
                id: id,
                inamovilidad: this.form
              }
            });
          } else {
            if (!this.cargado) {
              this.error = true;
              this.mensjageerror = "Debe seleccionar un archivo.";
              this.loading = false;
              return false;
            } else {
              this.error = false;
              this.mensjageerror = "";
            }
            this.form.id_estado = 1;
          let user = this.$storage.get("user");
            if (this.$route.params.id) {
              this.form.id_persona = parseInt(this.$route.params.id);
            } else {
              this.form.id_persona = user.id_persona;
            }
            await this.$service.graphql({
              query: `
								mutation add($inamovilidad: NewInamovilidad!){
									inamovilidadAdd(inamovilidad: $inamovilidad){
										id
									}
								}
							`,
              variables: {
                inamovilidad: this.form
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
        document.getElementById("input").value = "";
        this.$message.success();
        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/CrearActualizarInamovilidad.vue